import React, { useMemo } from 'react';
import { useApp } from '../context/AppContext';
import { StatCard } from '../components/StatCard';
import { Badge } from '../components/Badge';

const DEMO_COURSES = [
  {
    id: 'c1',
    title: 'Onboarding Spectra',
    category: 'onboarding',
    modality: 'async',
    status: 'active',
    progress: 72,
    participants: 48,
  },
  {
    id: 'c2',
    title: 'Prevención de lavado · compliance',
    category: 'compliance',
    modality: 'live',
    status: 'active',
    progress: 100,
    participants: 120,
  },
  {
    id: 'c3',
    title: 'Feedback para líderes',
    category: 'leadership',
    modality: 'blended',
    status: 'active',
    progress: 35,
    participants: 22,
  },
  {
    id: 'c4',
    title: 'APIs internas y automatización',
    category: 'technical',
    modality: 'async',
    status: 'draft',
    progress: 0,
    participants: 0,
  },
  {
    id: 'c5',
    title: 'Bienestar y pausas activas',
    category: 'wellness',
    modality: 'live',
    status: 'active',
    progress: 58,
    participants: 89,
  },
];

const CAT_BADGE = {
  onboarding: 'onboarding',
  compliance: 'cat_compliance',
  leadership: 'cat_leadership',
  technical: 'cat_technical',
  wellness: 'cat_wellness',
};

const STATUS_BADGE = {
  active: 'active',
  draft: 'draft',
  completed: 'approved',
};

export function Training() {
  const { t } = useApp();

  const kpis = useMemo(() => {
    const activeCourses = DEMO_COURSES.filter((c) => c.status === 'active').length;
    const enrolled = DEMO_COURSES.reduce((acc, c) => acc + c.participants, 0);
    const completed = DEMO_COURSES.filter((c) => c.progress === 100).length;
    const hours = DEMO_COURSES.length * 12 + 36;
    return { activeCourses, enrolled, completed, hours };
  }, []);

  return (
    <div className="page-stack people-suite-page people-suite-page--training">
      <div className="people-suite-hero">
        <p className="people-suite-hero__eyebrow">{t('trainings.eyebrow')}</p>
        <h2 className="people-suite-hero__title">{t('trainings.heroTitle')}</h2>
        <p className="people-suite-hero__lead">{t('trainings.heroLead')}</p>
        <span className="banner--muted people-suite-hero__banner">{t('trainings.demoBanner')}</span>
      </div>

      <div className="people-suite-kpis">
        <StatCard icon="▣" label={t('trainings.kpiActive')} value={kpis.activeCourses} tone="accent" />
        <StatCard icon="◉" label={t('trainings.kpiEnrolled')} value={kpis.enrolled} />
        <StatCard icon="✓" label={t('trainings.kpiCompleted')} value={kpis.completed} tone="success" />
        <StatCard icon="⏱" label={t('trainings.kpiHours')} value={kpis.hours} />
      </div>

      <div className="people-suite-two-col">
        <section className="panel panel--elevated people-suite-panel">
          <h3 className="people-suite-panel__title">{t('trainings.pathTitle')}</h3>
          <p className="panel__muted">{t('trainings.pathIntro')}</p>
          <ul className="people-suite-path">
            <li>
              <span className="people-suite-path__dot" />
              {t('trainings.path1')}
            </li>
            <li>
              <span className="people-suite-path__dot" />
              {t('trainings.path2')}
            </li>
            <li>
              <span className="people-suite-path__dot" />
              {t('trainings.path3')}
            </li>
          </ul>
        </section>

        <section className="panel panel--elevated people-suite-panel people-suite-panel--accent">
          <h3 className="people-suite-panel__title">{t('trainings.catalogTitle')}</h3>
          <ul className="people-suite-card-list">
            {DEMO_COURSES.map((c) => (
              <li key={c.id} className="people-suite-course-card">
                <div className="people-suite-course-card__head">
                  <div>
                    <div className="people-suite-course-card__title">{c.title}</div>
                    <div className="people-suite-course-card__tags">
                      <Badge variant={CAT_BADGE[c.category] || 'mutedFallback'}>{t(`trainings.cat_${c.category}`)}</Badge>
                      <span className="people-suite-pill">{t(`trainings.modality_${c.modality}`)}</span>
                      <Badge variant={STATUS_BADGE[c.status] || 'mutedFallback'}>{t(`trainings.status_${c.status}`)}</Badge>
                    </div>
                  </div>
                </div>
                <div className="people-suite-progress">
                  <div className="people-suite-progress__labels">
                    <span>{t('trainings.progress')}</span>
                    <span>{c.progress}%</span>
                  </div>
                  <div className="people-suite-progress__bar" role="progressbar" aria-valuenow={c.progress} aria-valuemin={0} aria-valuemax={100}>
                    <div className="people-suite-progress__fill" style={{ width: `${c.progress}%` }} />
                  </div>
                  <div className="people-suite-course-card__foot">
                    {t('trainings.participants')}: <strong>{c.participants}</strong>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </section>
      </div>

    </div>
  );
}
